var map = {
	"./CharteredPlanUploadTemplate.xlsx": 84779,
	"./GeofenceUploadTemplate.xlsx": 41652,
	"./HolidayUploadTemplate.xlsx": 78650,
	"./InHouseVehicleUploadTemplate.xlsx": 58237,
	"./InboundOrderRateTemplate.xlsx": 94006,
	"./InboundOrdersCustUploadTemplate.xlsx": 63497,
	"./InboundOrdersUploadTemplate.xlsx": 51406,
	"./LonghaulCommissionUploadTemplate.xlsx": 2815,
	"./PartnerVehicleUploadTemplate.xlsx": 83700,
	"./Power_of_Attorney_Letter_2021_V1.0.pdf": 97835,
	"./PreBookingTemplate.xlsx": 85575,
	"./PreBookingTemplateForStaff.xlsx": 75936,
	"./RoutePlanDriverUploadTemplate.xlsx": 94710,
	"./RouteUploadTemplate.xlsx": 60259,
	"./SlaRateChartTemplate.xlsx": 24175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95730;